import { TFN_DECLARATION } from '@/core/field-names';
import { fillDocumentFields } from '@/core/documents/fill-document.js';
import { TFN_RESIDENT_STATUS_VALUES } from '@/core/field-names';

export function fillTFNDeclaration(document, changedField) {
  let dependentFieldNames;
  let newValue;
  switch (changedField.name) {
    case TFN_DECLARATION.RESIDENT_STATUS:
      if (
        [
          TFN_RESIDENT_STATUS_VALUES.FOREIGN,
          TFN_RESIDENT_STATUS_VALUES.WORKING_HOLIDAY,
        ].includes(changedField.value)
      ) {
        dependentFieldNames = [
          TFN_DECLARATION.TAX_FREE_THRESHOLD,
          TFN_DECLARATION.HELP_LOAN_OR_STUDENT_DEBT,
        ];
        newValue = 'no';
        return fillDocumentFields(dependentFieldNames, document, newValue);
      }

      if (changedField.value !== TFN_RESIDENT_STATUS_VALUES.WORKING_HOLIDAY) {
        dependentFieldNames = [TFN_DECLARATION.COUNTRY_OF_ORIGIN];
        newValue = '';
        return fillDocumentFields(dependentFieldNames, document, newValue);
      }
      break;
    case TFN_DECLARATION.OPTION:
      if (changedField.value === 'No') {
        dependentFieldNames = [TFN_DECLARATION.TFN];
        newValue = '';
        return fillDocumentFields(dependentFieldNames, document, newValue);
      } else if (changedField.value === 'Yes') {
        dependentFieldNames = [TFN_DECLARATION.REASON, TFN_DECLARATION.TFN];
        newValue = '';
        return fillDocumentFields(dependentFieldNames, document, newValue);
      }
      break;
  }
  return document.fields;
}
